import { ChevronDown, PlusCircle } from '@tamagui/lucide-icons';
import { Row } from '@unistocks/components/layout/flex';
import { UnistocksCircle } from '@unistocks/components/logo/unistocks-circle';
import { Page } from '@unistocks/components/page/page';
import { Select } from '@unistocks/components/select/select';
import { selectSelectedPortfolioId } from '@unistocks/features/portfolios/store/portfolio.slice';
import { t } from '@unistocks/localization';
import { ListResultDtoOfLookupDtoOfGuid } from '@unistocks/proxy/axios-client';
import { usePortfoliosGetListQuery } from '@unistocks/proxy/axios-client/PortfoliosQuery';
import { useAppSelector } from '@unistocks/shared/hooks/redux-hooks';
import { SelectOption } from '@unistocks/types';
import { useRouter } from 'expo-router';
import React, { PropsWithChildren, useCallback } from 'react';
import { isWeb, Spinner } from 'tamagui';

export const PortfolioHeaderTitle: React.FC<PropsWithChildren> = ({ children }) => {
  const router = useRouter();
  const selected = useAppSelector(selectSelectedPortfolioId) ?? '';
  const {
    data: portfolios,
    isSuccess,
    isLoading
  } = usePortfoliosGetListQuery({
    structuralSharing: false,
    select: useCallback(
      ({ items }: ListResultDtoOfLookupDtoOfGuid) =>
        items
          .map(
            ({ id, displayName }) =>
              ({ key: displayName, value: id, icon: <UnistocksCircle /> }) as SelectOption
          )
          .concat([
            {
              key: t('::AddWhat', { 0: t('::Portfolio').toLocaleLowerCase() }),
              value: 'add',
              icon: <PlusCircle color={'$success'} />
            }
          ]),
      []
    )
  });

  const onSelect = useCallback(
    (value: string) => {
      if (value === 'add') {
        return router.navigate('/(tabs)/portfolios/create');
      }

      router.setParams({ id: value });
    },
    [router]
  );

  if (isLoading) return <Spinner color={'$headingFont'} />;

  if (isSuccess) {
    if (isWeb) {
      return <Page.Heading>{children}</Page.Heading>;
    }

    return (
      <Select
        options={portfolios}
        value={selected}
        onChange={onSelect}
        isRequired
        headerTitle={t('::SelectWhat', { 0: t('::Portfolio').toLocaleLowerCase() })}
        trigger={
          <Row gap={'$1'} alignItems={'center'}>
            <Page.Heading>{children}</Page.Heading>
            <ChevronDown color={'$headingFont'} />
          </Row>
        }
      />
    );
  }

  return null;
};
